import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function MetricsChart({ data }) {
  return (
    <div style={{ width: "100%", height: 360 }}>
      <ResponsiveContainer>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="pageViews" name="Page Views" stroke="#1677ff" />
          <Line type="monotone" dataKey="whatsappClicks" name="Cliques WhatsApp" stroke="#52c41a" />
          <Line type="monotone" dataKey="sessions" name="Sessões" stroke="#faad14" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}